import React, { useRef, useState } from "react";
import { Formik, Form } from "formik";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";

import ScannerInput from "src/components/form/ScannerInput";
import ProjectFilter from "src/layouts/ShoppingLayout/ProjectFilter";

export default function AddItemSearchModal({ onSearch, onClose, defaultProjectId }) {
  const [selectedProjectId, setSelectedProjectId] = useState(defaultProjectId || "");
  const searchInputRef = useRef(null);

  const handleSubmit = values => {
    if (values.code.trim()) {
      onSearch(values.code.trim(), selectedProjectId || null);
    }
  };

  const handleDetected = code => {
    if (code.trim()) {
      onSearch(code.trim(), selectedProjectId || null);
    }
  };

  return (
    <Dialog
      open
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      TransitionProps={{ onEntered: () => searchInputRef.current?.focus() }}
    >
      <DialogTitle sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <Typography fontSize={24} fontWeight={500} color="textPrimary" align="center">
          Item Search
        </Typography>
        <IconButton onClick={onClose} sx={{ position: "absolute", right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ minHeight: 180 }}>
        <Box sx={{ mt: 1, mb: 2 }}>
          <ProjectFilter
            size="small"
            label="Search Within"
            projectId={selectedProjectId}
            onSelectProject={id => setSelectedProjectId(id || "")}
          />
        </Box>
        <Formik initialValues={{ code: "" }} onSubmit={handleSubmit}>
          {({ values }) => (
            <Form>
              <ScannerInput
                autoFocus
                inputRef={searchInputRef}
                size="large"
                name="code"
                label="Search"
                showNAButton={false}
                onDetected={handleDetected}
                scanContainerProps={{ justifyContent: "flex-start" }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton type="submit" disabled={!values.code.trim()}>
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
}
